export default __webpack_public_path__ + "static/media/cms.41f226ef.jpg";